<template>
  <div class="breadcrumbs p-3">
    <a href="/">Αρχική</a> / <strong>Επικοινωνία</strong>
  </div>
  <div class="login-wrapper d-flex flex-column justify-content-center py-5">
    <div class="row justify-content-center">
      <div class="col-lg-6">
        <div class="card shadow-sm">
          <div class="card-body p-5">
            <h3 class="card-title text-center mb-3">Eπικοινωνήστε μαζί μας</h3>

            <form @submit.prevent="handleSubmit" novalidate>
              <div class="mb-3">
                <label class="form-label">Όνομα</label>
                <input
                  v-model="form.name"
                  type="text"
                  class="form-control"
                  placeholder="Το όνομα σας"
                  :class="{ 'is-invalid': errors.name }"
                />
                <div class="invalid-feedback">{{ errors.name }}</div>
              </div>

              <div class="mb-3">
                <label class="form-label">Email</label>
                <input
                  v-model="form.email"
                  type="email"
                  class="form-control"
                  placeholder="you@example.com"
                  :class="{ 'is-invalid': errors.email }"
                />
                <div class="invalid-feedback">{{ errors.email }}</div>
              </div>

              <div class="mb-3">
                <label class="form-label">Μήνυμα</label>
                <textarea
                  v-model="form.message"
                  rows="5"
                  class="form-control"
                  placeholder="Το μήνυμα σας..."
                  :class="{ 'is-invalid': errors.message }"
                ></textarea>
                <div class="invalid-feedback">{{ errors.message }}</div>
              </div>

              <input v-model="form.website" class="form-control" type="text" name="website" style="display:none">
 
              <div class="d-flex justify-content-center">
                <button type="submit" class="sent-btn btn text-center">
                  Αποστολή Μηνύματος
                </button>
              </div>
              

              <div v-if="submitted" class="alert alert-success text-center mt-3">
                Το μήνυμα στάλθηκε επιτυχώς.
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue';
import { contactForm } from '@/services/user';

const form = reactive({
  name: '',
  email: '',
  message: '', 
  website: '',
})

const errors = reactive({
  name: '',
  email: '',
  message: '',
  website: '',
})

const submitted = ref(false)

function validate() {
  let valid = true
  errors.name = ''
  errors.email = ''
  errors.message = ''

 if (!form.name.trim()) {
    errors.name = 'Απαιτείται όνομα.'
    valid = false
  }
  if (!form.email.trim()) {
    errors.email = 'Απαιτείται email.'
    valid = false
  } else if (!/^\S+@\S+\.\S+$/.test(form.email)) {
    errors.email = 'Μη έγκυρη μορφή email.'
    valid = false
  }
  if (!form.message.trim()) {
    errors.message = 'Το μήνυμα δεν μπορεί να είναι κενό.'
    valid = false
  }


  return valid
}

async function handleSubmit() {
  if (!validate()) return;

  const payload = {
    name: form.name,
    email: form.email, 
    message: form.message,
    website: form.website 
  };

  const result = await contactForm(payload);

  if(result.success){
    submitted.value = true;

    // Reset form
    form.name = '';
    form.email = '';
    form.message = '';
  }
}

</script>

<style scoped>


.sent-btn{
  background-color: #af0036;
  color:#fff;
  font-weight: 700;
  font-size: 18px;
}

.sent-btn:hover{
  background-color: #af0036;
  color:#fff;
}

.form-label{
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 0;
}


@media (max-width: 576px) {


}



</style>
